export function getCASCColors() {
  return ["mandarin", "carnation", "seablue", "platinum", "lagoon", "buttercup", "lillac", "forgetmenot"]
}

export function getCASCThemes() {
  return [
    "theme-mandarin",
    "theme-carnation",
    "theme-seablue",
    "theme-platinum",
    "theme-lagoon",
    "theme-buttercup",
    "theme-lillac",
    "theme-forgetmenot",
  ]
}

export function getCASCThemesInverted() {
  return [
    "theme-mandarin-inverted",
    "theme-carnation-inverted",
    "theme-seablue-inverted",
    "theme-platinum-inverted",
    "theme-lagoon-inverted",
    "theme-buttercup-inverted",
    "theme-lillac-inverted",
    "theme-forgetmenot-inverted",
  ]
}

export function getCASCAllThemes() {
  return ["", "theme-taxfree", ...getCASCThemes(), "theme-taxfree-inverted", ...getCASCThemesInverted()]
}

export function getCustomColors(props) {
  const style = {}

  if (props.backgroundColor && props.backgroundColor !== "") {
    style["--bg"] = props.backgroundColor
  }
  if (props.backgroundHoverColor && props.backgroundHoverColor !== "") {
    style["--bgh"] = props.backgroundHoverColor
  }
  if (props.textColor && props.textColor !== "") {
    style["--c"] = props.textColor
  }
  if (props.textHoverColor && props.textHoverColor !== "") {
    style["--ch"] = props.textHoverColor
  }

  return style
}

export default { getCustomColors, getCASCColors, getCASCThemes, getCASCThemesInverted, getCASCAllThemes }
